import {useApp} from 'hooks/StateHooks'
import {get} from 'lodash'

export type Translations = {
  [key: string]: string
}

export function translate(value: string, translations?: Translations) {
  translations = translations || useApp().translations

  const translation = get(translations, value, false)

  if (value && translation === false) {
    window.axios.post('/missing-translations', {translation: value})
  }

  return translation || value
}